/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyImageDto
 */
export interface PropertyImageDto {
    /**
     * 
     * @type {string}
     * @memberof PropertyImageDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyImageDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyImageDto
     */
    cdnUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyImageDto
     */
    caption?: string;
}

/**
 * Check if a given object implements the PropertyImageDto interface.
 */
export function instanceOfPropertyImageDto(value: object): value is PropertyImageDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function PropertyImageDtoFromJSON(json: any): PropertyImageDto {
    return PropertyImageDtoFromJSONTyped(json, false);
}

export function PropertyImageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyImageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'cdnUrl': json['cdnUrl'] == null ? undefined : json['cdnUrl'],
        'caption': json['caption'] == null ? undefined : json['caption'],
    };
}

export function PropertyImageDtoToJSON(json: any): PropertyImageDto {
    return PropertyImageDtoToJSONTyped(json, false);
}

export function PropertyImageDtoToJSONTyped(value?: PropertyImageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'cdnUrl': value['cdnUrl'],
        'caption': value['caption'],
    };
}

